import axios from 'axios';
import { ACTION_TYPES, API_BASE_URL, PAGE_TYPES } from '../contants';
declare global {
  interface Window {
    Shopify?: any;
    ShopifyAnalytics?: any;
  }
}

async function fetch(
  postId: string,
  userId: string,
  guid: string,
  pcat?: string,
  pid?: string,
  reTarget?: any,
  params?: any,
): Promise<any> {
  const visitedProducts = localStorage.getItem('visitedProducts');
  const endpoint = API_BASE_URL() + `/analytics/clicks`;
  let w_pid = pid;
  let w_pcat = pcat;
  if (window?.Shopify?.shop?.includes('myshopify.com')) {
    if (window?.ShopifyAnalytics?.meta?.product?.id) w_pid = window?.ShopifyAnalytics?.meta?.product?.id;
    if (window?.ShopifyAnalytics?.meta?.product?.type) w_pcat = window?.ShopifyAnalytics?.meta?.product?.type;
  }

  const body: any = { postId, userId, guid, ...params };

  if (reTarget && visitedProducts) {
    body.atcType = ACTION_TYPES.reTarget;
  }
  /*if (w_pcat) {
    endpoint = generateApiParams(endpoint, { pageType: PAGE_TYPES.category });
  }

  if (w_pid) {
    endpoint = generateApiParams(endpoint, { pageType: PAGE_TYPES.product });
  }
  endpoint = generateApiParams(endpoint, { pageLink: window.location.href });*/
  return await axios
    .post(endpoint, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(({ data }) => data as any)
    .catch(() => undefined);
}

export default function useClick(
  userId: string,
  guid: string,
  pcat?: string,
  pid?: string,
  retarget?: any,
  isRedis?: any,
) {
  const mutate = (postId: string, params: any) => {
    if (!isRedis) {
      fetch(postId, userId, guid, pcat, pid, retarget, params);
    }
  };

  return { mutate };
}
